import { call, fork, put, takeEvery } from 'redux-saga/effects';
import * as ga from '../../redux/actions/app';

import {
  getAnalystThroughputDataSuccess,
  NS_GET_ANALYSIS_THROUGHPUT_DATA
} from '../../redux/actions/ns/analystThroughput';

import { getAnalystThroughput } from '../../services/ns/analystThroughput';

function* getAnalystThroughputDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getAnalystThroughput, payload);
    yield put(getAnalystThroughputDataSuccess(response.data));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetAnalystThroughputData() {
  yield takeEvery(NS_GET_ANALYSIS_THROUGHPUT_DATA, function* ({ payload }) {
    yield fork(getAnalystThroughputDataWorker, payload);
  });
}
